// src/components/layouts/renderers/ModelXFrame.tsx
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { LayoutRendererProps, ModelXConfig } from '@/lib/layouts/types';
import { layoutHeadlineCss, SYSTEM_SANS } from '@/lib/layouts/headlineStyle';
import { useLayerFont } from '@/hooks/use-layer-font';

export const ModelXFrame: React.FC<LayoutRendererProps<ModelXConfig>> = ({ config, media }) => {
  useLayerFont(config.headlineFontFamily, config.headlineFontUrl);
  const postTextCss = layoutHeadlineCss(config, {
    color: '#0f1419',
    fontSize: 48,
    fontFamily: SYSTEM_SANS,
  });
  return (
    <AbsoluteFill
      data-testid="model-x-root"
      style={{
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 60,
        fontFamily: SYSTEM_SANS,
      }}
    >
      <div
        data-testid="model-x-header"
        style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 28, width: '100%' }}
      >
        {config.avatarUrl
          ? <img src={config.avatarUrl} alt="" style={{ width: 110, height: 110, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
          : <div style={{ width: 110, height: 110, borderRadius: '50%', backgroundColor: '#d1d5db', flexShrink: 0 }} />}
        <div data-testid="model-x-identity" style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <div style={{ fontSize: 44, fontWeight: 700, color: '#0f1419', lineHeight: 1.2 }}>{config.displayName}</div>
          <div style={{ fontSize: 36, color: '#536471', lineHeight: 1.3, marginTop: 6 }}>{config.handle}</div>
        </div>
      </div>
      <div
        data-testid="model-x-post-text"
        data-autocut-over=""
        style={{ lineHeight: 1.35, marginBottom: 32, width: '100%', ...postTextCss }}
      >
        {config.postText}
      </div>
      <div style={{ width: '100%', aspectRatio: '16 / 9', borderRadius: 24, overflow: 'hidden', backgroundColor: '#000', flexShrink: 0, position: 'relative' }}>
        {media}
      </div>
    </AbsoluteFill>
  );
};
